import {
    Component,
    ElementRef,
    EventEmitter,
    forwardRef,
    HostListener,
    Input,
    OnDestroy,
    OnInit,
    Output
} from "@angular/core";
import {AbstractControl, FormControl, NG_VALUE_ACCESSOR} from "@angular/forms";
import {Subscription} from "rxjs";
import {debounceTime, distinctUntilChanged} from "rxjs/operators";
import {AggregationGroupModel} from "../../../models/search/aggregations/aggregation-group.model";
import {AggregationItemModel} from "../../../models/search/aggregations/aggregation-item.model";
import {FormControlBaseComponent} from "../form-control-base/form-control-base.component";

@Component({
    selector: "pcg-ng-autocomplete",
    template: require('./autocomplete.component.html'),
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => AutocompleteComponent), multi: true}
    ]
})
export class AutocompleteComponent extends FormControlBaseComponent<string> implements OnInit, OnDestroy {
    private inputSubscription: Subscription;

    public formControl: AbstractControl = new FormControl(this.DEFAULT_VALUE);

    @Input()
    public propertyName: string;

    @Input()
    public propertyAlias: string;

    @Input()
    public suggestions: AggregationGroupModel;

    @Output()
    public searchForSuggestions: EventEmitter<string>  = new EventEmitter<string>();

    @HostListener("document:click", ["$event"])
    public hideSuggestions($event: Event): void {
        const clickInside = this.elementRef.nativeElement.contains(event.target);
        if (!clickInside) {
            this.clearSuggestions();
        }
    }

    public constructor(
        private elementRef: ElementRef
    ) {
        super(/*DEFAULT_VALUE*/"");
    }

    public ngOnInit(): void {
        this.inputSubscription = this.formControl.valueChanges
            .pipe(
                debounceTime(250),
                distinctUntilChanged()
            )
            .subscribe(value => {
                this.writeNewValue(value);
                if (value) {
                    this.searchForSuggestions.emit(value);
                }
            });
    }

    public ngOnDestroy(): void {
        if (this.inputSubscription) {
            this.inputSubscription.unsubscribe();
            this.inputSubscription = null;
        }
    }

    public writeValue(value: any): void {
        super.writeValue(value);
        this.formControl.setValue(value, {emitEvent: false});
    }

    public handleSelection(selection: AggregationItemModel): void {
        this.writeNewValue(selection.value);
        this.clearSuggestions();
    }

    public clearSuggestions(): void {
        this.suggestions = null;
    }
}
